import { toast } from "@zerodevx/svelte-toast";

const successTheme = {
    "--toastBackground": "#6F6",
    "--toastColor": "#060",
    "--toastBarBackground": "#060",
};

const infoTheme = {
    "--toastBackground": "#9DF",
    "--toastColor": "#039",
    "--toastBarBackground": "#039",
};

const warningTheme = {
    "--toastBackground": "#FF6",
    "--toastColor": "#660",
    "--toastBarBackground": "#660",
};

const errorTheme = {
    "--toastBackground": "#F66",
    "--toastColor": "#600",
    "--toastBarBackground": "#600",
};

export const successToast = (msg: string) => pushToast(msg, successTheme);
export const infoToast = (msg: string) => pushToast(msg, infoTheme);
export const warningToast = (msg: string) => pushToast(msg, warningTheme);
export const errorToast = (msg: string) => pushToast(msg, errorTheme);

const pushToast = (message: string, theme: any) =>
    toast.push(message, {
        theme,
        pausable: true,
    });
